import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    NotificationPredefinedTemplatesCreateRequest,
    NotificationPredefinedTemplatesUpdateRequest
} from '@/modules/configurationModule/detail/notifications/models/notification-predefined-templates'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { PredefinedCustomNotificationResponse } from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.dto'

class PredefinedCustomNotificationConfigurationService {
    async create(request: NotificationPredefinedTemplatesCreateRequest, laboratoryId: number): Promise<PredefinedCustomNotificationResponse> {
        const response =
            await axios.post<PredefinedCustomNotificationResponse>(
                `/configuration/laboratories/${laboratoryId}/predefinedCustomNotifications`,
                request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<PredefinedCustomNotificationResponse>> {
        const response =
            await axios.put<IResponseAgGrid<PredefinedCustomNotificationResponse>>(
                `/configuration/laboratories/${laboratoryId}/predefinedCustomNotifications`,
                { ...filterModel },
                { params })
        return response.data
    }

    async get(laboratoryId: number, predefinedCustomNotificationId: number): Promise<PredefinedCustomNotificationResponse> {
        const response =
            await axios.get<PredefinedCustomNotificationResponse>(
                `/configuration/laboratories/${laboratoryId}/predefinedCustomNotifications/${predefinedCustomNotificationId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.delete<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/predefinedCustomNotifications/batch`,
                { data: request })
        return response.data
    }

    async patch(request: NotificationPredefinedTemplatesUpdateRequest[], laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.patch<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/predefinedCustomNotifications/batch`,
                request)
        return response.data
    }
}
export const predefinedCustomNotificationConfigurationService = new PredefinedCustomNotificationConfigurationService()
